import React from 'react';

export const TooltipIcon = ({ size = 20, color = "#2E2E2E" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_4_20653)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 1.76514C5.51269 1.76514 1.875 5.40282 1.875 9.89014C1.875 14.3774 5.51269 18.0151 10 18.0151C14.4873 18.0151 18.125 14.3774 18.125 9.89014C18.125 5.40282 14.4873 1.76514 10 1.76514ZM0.625 9.89014C0.625 4.71247 4.82233 0.515137 10 0.515137C15.1777 0.515137 19.375 4.71247 19.375 9.89014C19.375 15.0678 15.1777 19.2651 10 19.2651C4.82233 19.2651 0.625 15.0678 0.625 9.89014Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 8.76748C10.4142 8.76748 10.75 9.10327 10.75 9.51748V14.5175C10.75 14.9317 10.4142 15.2675 10 15.2675C9.58579 15.2675 9.25 14.9317 9.25 14.5175V9.51748C9.25 9.10327 9.58579 8.76748 10 8.76748Z"
        fill={color}
      />
      <path
        d="M10.9972 6.47995C10.9972 7.03082 10.5507 7.47738 9.99981 7.47738C9.44894 7.47738 9.00238 7.03082 9.00238 6.47995C9.00238 5.92909 9.44894 5.48252 9.99981 5.48252C10.5507 5.48252 10.9972 5.92909 10.9972 6.47995Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_4_20653">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Tooltip.icon.jsx